<p-drawer [(visible)]="showSideBar" position="right" styleClass="cp-drawer">
  <ng-template #header>
    <h5 class="notice-header cp-drawer-title">Notice Center</h5>
  </ng-template>
  <div class="cp-drawer-body">
    @if (sortedNotices().length > 0) {
      @for (dto of sortedNotices(); track dto) {
        <notice-card [notice]="dto" (closeSidebar)="oncloseSidebar()" (dismissNotice)="onDismissNotice($event)" />
      }
    }
    @else {
        No Notifications Available
    }
  </div>

  <div class="cp-drawer-footer">
    <pcp-commandbar>
      <command-button button-left text="Close"
                      [iconClasses]="['fas fa-window-close']"
                      (commandClick)="oncloseSidebar()" />
    </pcp-commandbar>
  </div>
</p-drawer>

@if (showSideBar) {
  <div class="drawer-mask"></div>
}
